import { useState, useEffect, useMemo } from "react";
import { where } from "firebase/firestore";
import CaseComponent from "../../components/CaseComponents/CaseComponent";
import Navbar from "../../components/ValuatorNavbar"
import useFetchData from "../../hooks/ValuatorHooks/useFetchData";
import LoadingComponent from "../../components/LoadingComponent";
import { useSelectedCompany } from "../../contexts/SelectedCompanyContext";
import useFetchCompanyId from "../../hooks/CompanyHooks/useFetchCompanyId";
import useFetchCompanies from "../../hooks/useFetchCompanies";


function CaseListPage() {
  const { selectedCompany, setSelectedCompany } = useSelectedCompany();
  const { companyId } = useFetchCompanyId(selectedCompany);
  const {companies, loading, error} = useFetchCompanies();


  
  const caseQueryParams = useMemo(() => [where('done', '==', true), where('archived', '!=', true)], [companyId]);
  const {
    data: cases,
    error: casesError,
    loading: casesLoading
  } = useFetchData(companyId ? `companies/${companyId}/cases` : null, null, caseQueryParams);


return (
<>
            <Navbar />
            {casesLoading ? <LoadingComponent /> : (
                <>
                    {casesError && <p>Error fetching cases: {casesError}</p>}
                    <CaseComponent selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} companies={companies} cases={cases || []} />
                </>
            )}
        </>
    );
}

export default CaseListPage;
